import { useState, useEffect } from 'react';
import { useAdminStatus } from './useAdminStatus';

export function useNotifications() {
  const { pendingAdmins, adminStatus } = useAdminStatus();
  const [notifications, setNotifications] = useState<Array<{
    id: string;
    type: 'info' | 'warning' | 'success' | 'error';
    title: string;
    message: string;
    timestamp: Date;
    read: boolean;
  }>>([]);

  useEffect(() => {
    if (adminStatus === 'APPROVED' && pendingAdmins.length > 0) {
      const pendingNotification = {
        id: `pending-admins-${Date.now()}`,
        type: 'warning' as const,
        title: 'Pending Admin Approvals',
        message: `${pendingAdmins.length} admin account${pendingAdmins.length > 1 ? 's' : ''} awaiting your review`,
        timestamp: new Date(),
        read: false,
      };

      setNotifications(prev => {
        // Remove existing pending admin notifications
        const filtered = prev.filter(n => !n.id.startsWith('pending-admins-'));
        return [pendingNotification, ...filtered];
      });
    } else {
      // Remove pending admin notifications if there are none
      setNotifications(prev => prev.filter(n => !n.id.startsWith('pending-admins-')));
    }
  }, [pendingAdmins.length, adminStatus]);

  const markAsRead = (id: string) => {
    setNotifications(prev => 
      prev.map(notification => 
        notification.id === id 
          ? { ...notification, read: true }
          : notification
      )
    );
  };

  const dismissNotification = (id: string) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return {
    notifications,
    unreadCount,
    markAsRead,
    dismissNotification,
  };
}
